<template>
    <v-card>
        <v-card-title class="subheading"><strong>Sort By</strong>
        <v-spacer/>
            <v-spacer/>
            <v-btn small @click="closeDialog" class="teal white--text">Apply </v-btn>
            <v-icon @click="closeDialog" small class="grey--text">fas fa-times</v-icon>
        
        </v-card-title>
        <hr>
        <v-card-text>
            <template v-for="column in headers">
                <v-chip close    small dense class="orange white--text" v-if="column.selected">
                    {{column.text}}-{{column.order ? 'Desc' : 'Asc'}}
                </v-chip>
            </template>
            <v-layout class="teal" row wrap>
                <v-flex xs2 style="padding:7px;margin:7px;" class="teal">
                    
                </v-flex>
                <v-flex xs7 style="padding:7px;margin:7px;" class="teal white--text">
                    Column Name
                </v-flex>
                <v-flex xs1  style="padding:7px;margin:7px;" class="teal white--text">
                    Descending
                </v-flex>
            </v-layout>
            <v-layout row wrap>
            <template v-for="column in headers">
                <v-flex xs2>
                 <v-checkbox style="padding:0px;margin-top:5px;" height="10px" 
                            @change="selectColumn(column)" v-model="column.selected"/>
                </v-flex>
                <v-flex xs7 style="padding:3px;margin:3px;" >
                    <span >{{column.text}}</span>
                </v-flex>
                <v-flex xs1>
                         <v-checkbox style="padding:0px;margin-top:5px;" height="10px" 
                          @change="selectColumn(column)"
                          v-model="column.order" small/>

                </v-flex>
            </template>
            </v-layout>
        </v-card-text>
    </v-card>    
</template>
<script>
export default {

    props: [
        "headers"
    ],
    data() {
        return {
            sortColumns: [
            
            ],
            columns: []
        }
    },
    mounted: function() 
    {
        this.sortColumns= Object.assign({},headers)
    },
    watch: {
       /* headers() {
            this.sortColumns = Object.assign({},headers)
        }*/
    },
    mounted:function() {

    },
    methods: {
        toggleSelected($column) {
            $column.selected = ! $column.selected
            this.$forceUpdate()
        },
        closeDialog() {
            var $keys = Object.keys(this.columns)
            var $sortKeys=[]
            for(var $i=0;$i<$keys.length;$i++) {
                $sortKeys.push($keys[$i])
            }
            this.$emit('applySort',$sortKeys)
        },
        selectColumn($column) {
            if($column.selected) {
            this.columns[$column.value]=$column.order 
            } else {
                delete this.columns[$column.value]    
            }
            this.$forceUpdate()
        }
    }
}
</script>
<style >
.v-input v-input--selection-controls v-input--checkbox theme--light
{
    height:"100px"
}
</style>